import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'Potwierdź adres e-mail',
  [OnboardingStep.StoreDetails]: 'Dane lokalu',
  [OnboardingStep.BusinessInfo]: 'Dane firmy',
  // Outside Germany, where Store details and Business details are still one step.
  store_and_business_info: 'Dodaj dane sklepu',
  [OnboardingStep.PersonalInfo]: 'Dodaj dane osobowe',
  // In Germany: the person who signs the contract, for a GmbH its managing director (Nishita).
  owner_personal_info: 'Dane osobowe właściciela',
  owner_personal_info_gmbh: 'Dane osobowe właściciela / dyrektora zarządzającego',
  [OnboardingStep.ShippingInfo]: 'Dodaj dane dostawy',
  [OnboardingStep.BankInfo]: 'Dodaj dane bankowe do wypłat',
  [OnboardingStep.TaxInfo]: 'Czy Twoja firma jest płatnikiem VAT?',
  [OnboardingStep.BusinessDocs]: 'Dokument potwierdzający działalność',
  [OnboardingStep.PersonalDocs]: 'Dokument tożsamości',
  [OnboardingStep.InfoSubmission]: 'Otrzymaj płatność',
  confirm_info_gateway: 'Otrzymaj płatność – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Informacje o płatności',
  [OnboardingStep.Subscription]: 'Subskrypcja',
  [OnboardingStep.MobileApp]: 'Aplikacja mobilna',
  [OnboardingStep.DeliveryStructure]: 'Struktura dostawy',
  [OnboardingStep.Contract]: 'Umowa',
  [OnboardingStep.ContractPayment]: 'Płatność za umowę',
  [OnboardingStep.Documents]: 'Prześlij dokumenty',
  [OnboardingStep.PromoCode]: 'Kod promocyjny',
};
